import {t} from 'i18next';
import {Box, Grid, Typography} from '@mui/material';
import AurDialog, {DialogProps} from '../../../common/aur-dialog/AurDialog';

interface MultiCustodianStructureTipsProps {
  showDialog: DialogProps['showDialog'];
  onCancel: DialogProps['onCancel'];
}

const custodianFolders = [
  'Doe, John',
  'Smith, Jane',
  'Reyes, Carlos',
  'Patel, Priya.pst',
  'Zipper, Andrew.pst',
  'Smith, John.zip',
  'Porter, Jason.zip',
];

const namingConventions = ['Lastname, Firstname'];

const MultiCustodianStructureTips = ({
  showDialog,
  onCancel,
}: MultiCustodianStructureTipsProps) => {
  const renderContent = () => (
    <Box className="multi-custodian-content popup-dialog-content-body-text">
      <Typography tabIndex={0} className="typo-text body2_size description">
        {t('uploadEvidence.multiCustodianModel.subtite1')}
        <br />
        {t('uploadEvidence.multiCustodianModel.subtite2')}
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={6}>
          <Box className="tips-card">
            <Typography
              tabIndex={0}
              className="typo-text subhead3_size"
              role="heading"
              aria-level={4}
            >
              {t('uploadEvidence.multiCustodianModel.containerFormat')}
            </Typography>

            <Box className="container-format">
              {custodianFolders.map((name, index) => (
                <Typography
                  tabIndex={0}
                  key={name}
                  component="div"
                  className="typo-text subhead4_size"
                >
                  {index === 0
                    ? `|- ${t(
                        'uploadEvidence.multiCustodianModel.dataZipLabel'
                      )}`
                    : new Array(20).fill('\u00A0').join('')}
                  /{name}
                </Typography>
              ))}
            </Box>
          </Box>
        </Grid>

        <Grid item xs={6}>
          <Box className="tips-card">
            <Typography
              tabIndex={0}
              className="typo-text subhead3_size naming-con-label"
              role="heading"
              aria-level={4}
            >
              {t('uploadEvidence.multiCustodianModel.namingConvention')}
            </Typography>

            <Box tabIndex={0} className="naming-list">
              {namingConventions.map((format) => (
                <span key={format}>{format}</span>
              ))}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );

  return (
    <AurDialog
      showDialog={showDialog}
      className="multi-custodian-dialog confirmation-popup-modal popup"
      popupContent={renderContent()}
      isTextContent={false}
      dismissable={false}
      popupTitle={t('uploadEvidence.multiCustodianModel.title')}
      labelActionOk={t('buttons.close')}
      okLabelClassName="tips-close-button"
      okActionTabIndex={0}
      onCancel={onCancel}
      onOk={onCancel}
    />
  );
};

export default MultiCustodianStructureTips;
